<template>
  <div class="clients">
    <header class="d-sm-flex justify-content-between align-items-center">
      <h1>Clientes</h1>
      <b-button :to="{name: 'ClientNew'}" variant="outline-primary">Nuevo Cliente</b-button>
    </header>
    <hr>
    <LoadingData v-if="isGetClientsLoading"/>
    <template v-else>
      <template v-if="isClientsListEmpty">
        <p class="lead">De momento no hay productos...</p>
      </template>
      <template v-else>
        <b-table striped borderless hover :items="clients" :fields="tableFields" responsive="sm" @row-clicked="rowClicked"/>
      </template>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { dateMixin } from '@/mixins/dateMixin'
import LoadingData from '@/components/LoadingData'

export default {
  name: 'Clients',
  components: { LoadingData },
  mixins: [dateMixin],
  created () {
    this.loadClients()
  },
  data () {
    return {
      isGetClientsLoading: true,
      isClientsListEmpty: null,
      clients: [],
      tableFields: [
        {
          key: 'name',
          label: 'Nombre',
          sortable: true
        },
        {
          key: 'phone',
          label: 'Telf.'
        },
        {
          key: 'address',
          label: 'Dirección',
          sortable: true
        },
        {
          key: 'createdAt',
          label: 'Fecha Alta'
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'getClients'
    ]),
    loadClients () {
      this.getClients()
        .then((res) => {
          this.isGetClientsLoading = false
          if (res.empty) {
            this.isClientsListEmpty = true
            return false
          }
          res.forEach(doc => {
            this.clients.push({ id: doc.id, ...doc.data(), createdAt: this.dateDDMMYYYY(doc.data().createdAt) })
          })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    rowClicked (item, index, ev) {
      this.$router.push({ name: 'ClientDetail', params: { clientId: item.id } })
    }
  }
}
</script>
